import { wrap, unwrap, scrollTop } from '../tools/utils';
import { fontLoader } from './fontFaceObserver';
import { MQ } from '../tools/MQ';
import * as Event from '../tools/Event';
import * as Emmiter from '../tools/Emmiter';


export const init = () => {
	const elements = [...document.querySelectorAll('[data-sticky]')];

	const init = (element) => {
		if (!element) return;

		const holder = element.closest('[data-sticky-container]');
		const wrapper = document.createElement('div');
		const BREAKPOINT = 'tabletMin';

		let isInit = false;
		let state = null;
		let rectHolder = null;
		let rectWrapper = null;
		let rectElement = element.getBoundingClientRect();
		let maxHeight = null;
		let minTop = null;
		let maxTop = null;
		let lastDocumentHeight = document.body.clientHeight;
		let documentHeightChecker;

		const checkDocumentHeightChange = () => setInterval(() => {
			const documentHeight = document.body.clientHeight;

			if (documentHeight > lastDocumentHeight) {
				Emmiter.trigger('sticky-recalc');
				lastDocumentHeight = documentHeight;
			}
		}, 500);

		const setWrapperHeight = () => {
			wrapper.style.height = `${maxHeight}px`;
		};

		const initSticky = () => {
			if (!MQ(BREAKPOINT)) return;

			if (!isInit) {
				wrap(element, wrapper);
				documentHeightChecker = checkDocumentHeightChange();
				isInit = true;
				Event.on(window, 'scroll', onScroll);
			}

			rectHolder = holder.getBoundingClientRect();
			rectWrapper = wrapper.getBoundingClientRect();
			rectElement = element.getBoundingClientRect();
			maxHeight = Math.round(rectHolder.height - wrapper.offsetTop);
			minTop = Math.round(rectWrapper.top + scrollTop()) - 15;
			maxTop = Math.round(minTop + maxHeight - rectElement.height);
			state = null;

			setWrapperHeight();
			onScroll();
		};

		const destroySticky = () => {
			if (!isInit) return;

			element.style.position = '';
			element.style.top = '';
			element.style.left = '';
			element.style.msTransform = '';
			element.style.webkitTransform = '';
			element.style.transform = '';
			element.style.width = '';

			unwrap(element);
			clearInterval(documentHeightChecker);
			isInit = false;

			Event.off(window, 'scroll', onScroll);
		};


		const onScroll = () => {
			const top = scrollTop();
			const left = Math.round(rectWrapper.left);

		// min
			if (top <= minTop) {
				if (state !== -1) {
					element.style.position = '';
					element.style.top = '';
					element.style.left = '';
					element.style.msTransform = '';
					element.style.webkitTransform = '';
					element.style.transform = '';
					element.style.width = '';
					state = -1;
				}
			}
		// max
			else if (top >= maxTop) {
				if (state !== 1) {
					element.style.position = '';
					element.style.top = '';
					element.style.left = '';
					element.style.msTransform = `translate(0, ${maxTop - minTop}px)`;
					element.style.webkitTransform = `translate(0, ${maxTop - minTop}px)`;
					element.style.transform = `translate(0, ${maxTop - minTop}px)`;
					element.style.width = '';
					state = 1;
				}
			}
		// fixed
			else if (state !== 0) {
				element.style.position = 'fixed';
				element.style.top = 0;
				element.style.left = 0;
				element.style.msTransform = `translate(${left}px , ${15}px)`;
				element.style.webkitTransform = `translate(${left}px , ${15}px)`;
				element.style.transform = `translate(${left}px , ${15}px)`;
				element.style.width = `${rectElement.width}px`;
				state = 0;
			}
		};

		const onResize = () => {
			if (MQ(BREAKPOINT)) {
				initSticky();
			} else {
				destroySticky();
			}
		};


		initSticky();

		Event.on(window, 'resize', onResize);
		Emmiter.on('sticky-recalc', onResize);
		fontLoader.then(onResize);
	};

	elements.forEach(init);
};



// WEBPACK FOOTER //
// ./src/js/components/sticky.js